var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-checkbox',{on:{"change":_vm.onChange},model:{value:(_vm.grid.filter[_vm.prop]),callback:function ($$v) {_vm.$set(_vm.grid.filter, _vm.prop, $$v)},expression:"grid.filter[prop]"}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }